// document.addEventListener('DOMContentLoaded', function () {
// 	const header = document.querySelector('header');
// 	const searchForm = header
// 		? header.querySelector('.dgwt-wcas-search-form')
// 		: null;
// 	const searchInput = searchForm
// 		? searchForm.querySelector('.dgwt-wcas-search-input')
// 		: null;
// 	const searchResults = searchForm
// 		? searchForm.querySelector('.search-results')
// 		: null;

// 	// Exit early if no search input
// 	if (!searchForm || !searchInput) return;
// 	window.isSearchActive = false;
// 	function getScrollbarWidth() {
// 		return window.innerWidth - document.documentElement.clientWidth;
// 	}
// 	function fixBodyScroll() {
// 		const scrollbarWidth = getScrollbarWidth();
// 		document.body.classList.add('body-fixed');
// 	}

// 	function unfixBodyScroll() {
// 		document.body.classList.remove('body-fixed');
// 	}

// 	function updateSearchState() {
// 		const active =
// 			document.activeElement === searchInput ||
// 			searchInput.value.length > 0 ||
// 			(searchResults && searchResults.style.display !== 'none');

// 		if (window.isSearchActive !== active) {
// 			window.isSearchActive = active;

// 			if (active) {
// 				fixBodyScroll();
// 			} else {
// 				unfixBodyScroll();
// 			}

// 			// Trigger custom event for header state update
// 			const event = new CustomEvent('headerStateUpdate');
// 			document.dispatchEvent(event);
// 		}
// 	}
// 	// Input / focus / blur events
// 	searchInput.addEventListener('input', function () {
// 		setTimeout(updateSearchState, 50);
// 	});
// 	searchInput.addEventListener('focus', function () {
// 		setTimeout(updateSearchState, 50);
// 	});
// 	searchInput.addEventListener('blur', function () {
// 		setTimeout(updateSearchState, 50);
// 	});

// 	// Watch .search-results for visibility changes using MutationObserver
// 	if (searchResults) {
// 		const observer = new MutationObserver(updateSearchState);
// 		observer.observe(searchResults, {
// 			attributes: true,
// 			attributeFilter: ['style'],
// 		});
// 	}
// });
